<mat-chip [ngClass]="BadgeColor.get(status())">
  <span class="mat-body-medium">{{ status() }}</span>
</mat-chip>
